import { connect } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import Select from "react-select";

// Components
import { DomUtil, Control } from "leaflet";
import { MapControl, withLeaflet } from "react-leaflet";
import Tooltip from "vizzuality-components/dist/tooltip";

// Images
import BasemapIcon from "images/icons/basemap.svg";

// Constants
import { basemaps, labels, languages } from "../constants";

// Actions
import { setLanguageF } from "components/forecast-demo/actions";
import { setLanguage } from "components/emissions-demo/actions";

// Selectors
import { getSelectedLanguageF } from "components/forecast-demo/selectors";
import { getSelectedLanguage } from "components/emissions-demo/selectors";

// Styles
import "vizzuality-components/dist/tooltip.css";
import "vizzuality-components/dist/icon.css";
import "./style.css";

class BasemapLeafletControl extends Control {
  getProps() {
    return this.options;
  }

  onChangeLanguage = (language) => {
    const { setLanguage } = this.getProps();
    setLanguage(language);
    const { setLanguageF } = this.getProps();
    setLanguageF(language);
  }

  getOverlay = (
    basemaps,
    labels,
    basemap,
    label,
    language,
    setBasemap,
    setLabel,
    selectedLanguage,
  ) => {
    return (
      <div className="c-basemap-control">
        <div className="control-container">
          <h4>Basemaps</h4>
          <ul className="basemap-control-list">
            {Object.keys(basemaps).map(k => {
              const selectedClassName = classnames({
                "list-item-button": true,
                "-selected": basemaps[k].id === basemap,
              });

              return (
                <li
                  key={basemaps[k].id}
                  className="basemap-control-list-item"
                >
                  <div
                    role="button"
                    tabIndex="0"
                    className={selectedClassName}
                    onClick={() => setBasemap(basemaps[k].id)}
                  >
                    {basemaps[k].name}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="control-container">
          <h4>Labels</h4>
          <div className="language-selectors">
            <Select
              classNamePrefix="react-select basemap-control-list-item"
              placeholder="Language"
              options={languages}
              value={selectedLanguage}
              onChange={this.onChangeLanguage}
              menuPlacement="top"
            />
          </div>
          <ul className="basemap-control-list">
            {Object.keys(labels).map(k => {
              const selectedClassName = classnames({
                "list-item-button": true,
                "-selected": labels[k][language].id === label,
              });

              return (
                <li key={k} className="basemap-control-list-item">
                  <div
                    role="button"
                    tabIndex="0"
                    className={selectedClassName}
                    onClick={() => setLabel(labels[k][language].id)}
                  >
                    {labels[k][language].name}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  onAdd() {
    const {
      onClickBasemap,
      basemap,
      label,
      language,
      setBasemap,
      setLabel,
      selectedLanguage,
    } = this.getProps();

    const jsxTemplate = (
      <div className="c-basemap-control">
        <Tooltip
          overlay={this.getOverlay(
            basemaps,
            labels,
            basemap,
            label,
            language,
            setBasemap,
            setLabel,
            selectedLanguage,
          )}
          overlayClassName="c-rc-tooltip -default"
          overlayStyle={{ color: "#fff" }}
          placement="rightTop"
          trigger={["click"]}
          mouseLeaveDelay={0}
          destroyTooltipOnHide
        >
          <button
            type="button"
            className="basemap-button"
            aria-label="Basemap"
            title="Basemap"
            onClick={onClickBasemap}
          >
            <img src={BasemapIcon} alt="Basemap" />
          </button>
        </Tooltip>
      </div>
    );

    const container = DomUtil.get("leaflet-control-basemap-container");
    ReactDOM.render(jsxTemplate, container);
    return container;
  }
}

class BasemapControl extends MapControl {
  static propTypes = {
    basemap: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    setBasemap: PropTypes.func.isRequired,
    setLabel: PropTypes.func.isRequired,
  };

  componentDidUpdate() {
    this.element.getProps = () => ({ ...this.element.options, ...this.props });
    this.element.onAdd(this.container);
  }

  createLeafletElement(props) {
    this.element = new BasemapLeafletControl(props);
    return this.element;
  }
}

const mapStateToProps = state => ({
  emissionsMap: state.emissionsDemo.state.basemap,
  emissionsLabel: state.emissionsDemo.state.labels,
  forecastMap: state.forecastDemo.state.basemap,
  forecastLabel: state.forecastDemo.state.labels,
  languages,
  selectedLanguage: getSelectedLanguage(state),
  selectedLanguageF: getSelectedLanguageF(state),
});

const mapDispatchToProps = dispatch => ({
  setLanguage: language => dispatch(setLanguage(language)),
  setLanguageF: language => dispatch(setLanguageF(language)),
});

export default withLeaflet(
  connect(mapStateToProps, mapDispatchToProps)(BasemapControl),
);



// WEBPACK FOOTER //
// ./src/components/map/basemap-control/index.js